/* Alpine Outlets homepage: the combined Google rating and review count for both stores, from the same feed the
   Reputon reviews app loads; the newest items for the new-arrivals rail; and rotating price examples. If a request
   fails, the server-rendered content stays. */
(function () {
  if (window.aoHomeReady) return;
  window.aoHomeReady = true;

  var REVIEWS_FEED = 'https://grw.reputon.com/app/storefront/widget?lang=en&shop=';

  function fill(panel, rating, count) {
    var number = panel.querySelector('[data-aoh-rating-num]');
    if (number) number.textContent = rating;
    var copy = panel.querySelector('[data-aoh-rating-copy]');
    var template = panel.getAttribute('data-aoh-rating-text');
    if (!copy || !template) return;
    var p = document.createElement('p');
    template.split(/(\{rating\}|\{count\})/).forEach(function (part) {
      if (part === '{count}') {
        var strong = document.createElement('strong');
        strong.textContent = count.toLocaleString('en-US');
        p.appendChild(strong);
      } else if (part) {
        p.appendChild(document.createTextNode(part === '{rating}' ? rating : part));
      }
    });
    while (copy.firstChild) copy.removeChild(copy.firstChild);
    copy.appendChild(p);
  }

  function liveRating() {
    var panels = document.querySelectorAll('[data-aoh-rating]');
    if (!panels.length || !window.fetch) return;
    fetch(REVIEWS_FEED + encodeURIComponent(panels[0].getAttribute('data-aoh-rating')))
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        var count = 0;
        var weighted = 0;
        ((data && data.business) || []).forEach(function (business) {
          var reviews = Number(business.reviewsNumber);
          if (typeof business.rating !== 'number' || !(reviews > 0)) return;
          count += reviews;
          weighted += business.rating * reviews;
        });
        if (!count) return;
        var rating = (weighted / count).toFixed(1);
        panels.forEach(function (panel) { fill(panel, rating, count); });
      })
      .catch(function () { /* Keep the hand-set rating. */ });
  }

  /* The rail first shows items in the collection's own order. Shopify can only sort a whole collection by date on
     the collection's page, so this asks that page, sorted newest first, to render the rail section and keeps its
     cards. It waits until the rail is near the screen. */
  function newestRail() {
    if (!window.fetch || !window.DOMParser) return;
    document.querySelectorAll('[data-aoh-newest]').forEach(function (section) {
      if (section.getAttribute('data-aoh-state')) return;
      section.setAttribute('data-aoh-state', 'waiting');
      var rail = section.querySelector('.ao-rail');
      if (!rail) return;
      var load = function () {
        section.setAttribute('data-aoh-state', 'loading');
        fetch(section.getAttribute('data-aoh-newest'), { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (html) {
            var fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.ao-rail');
            if (!fresh || fresh.querySelectorAll('.ao-card').length < 4) return;
            var cards = Array.prototype.map.call(fresh.querySelectorAll('.ao-card'), function (card) { return document.importNode(card, true); });
            while (rail.firstChild) rail.removeChild(rail.firstChild);
            cards.forEach(function (card) { rail.appendChild(card); });
            rail.scrollLeft = 0;
            section.setAttribute('data-aoh-state', 'newest');
          })
          .catch(function () { /* Keep the server-rendered cards. */ });
      };
      if (!('IntersectionObserver' in window)) return load();
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        load();
      }, { rootMargin: '800px 0px' });
      observer.observe(section);
    });
  }

  /* The price examples carry a pool of the best current deals. Show a random few on each visit, kept in the pool's
     order (biggest savings first), so returning shoppers see different deals. */
  function rotateDeals() {
    document.querySelectorAll('[data-aoh-deals]').forEach(function (list) {
      if (list.getAttribute('data-aoh-rotated')) return;
      list.setAttribute('data-aoh-rotated', 'true');
      var cards = list.querySelectorAll('.ao-deal');
      var count = parseInt(list.getAttribute('data-aoh-deals'), 10) || 3;
      if (cards.length <= count) return;
      var order = [];
      for (var i = 0; i < cards.length; i++) order.push(i);
      for (var j = order.length - 1; j > 0; j--) {
        var k = Math.floor(Math.random() * (j + 1));
        var swap = order[j];
        order[j] = order[k];
        order[k] = swap;
      }
      var keep = order.slice(0, count);
      for (var n = 0; n < cards.length; n++) cards[n].hidden = keep.indexOf(n) === -1;
    });
  }

  function init() {
    liveRating();
    newestRail();
    rotateDeals();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
